import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './Accounts.scss';
import CardHeading from "../../../components/common/CardHeading/CardHeading.jsx";
import AccountTable from "./AccountTable/AccountTable.jsx";
import { useSelector } from 'react-redux';
import { filterBalanceWalletForTradeWallet } from '../../../services/wallet/linkedWallet.utils';
const Accounts = ({
  sectionRef
}) => {
  const rootRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const activePairBalance = useSelector(state => state.ats.activePairBalance);
  const selectedTradeWallet = useSelector(state => state.ats.selectedTradeWallet);
  const walletList = useMemo(() => {
    if (!selectedTradeWallet || !activePairBalance?.wallet?.length) {
      return [];
    }
    return filterBalanceWalletForTradeWallet(activePairBalance.wallet, selectedTradeWallet);
  }, [activePairBalance, selectedTradeWallet]);
  const setAccountsRootRef = useCallback(node => {
    rootRef.current = node;
    if (typeof sectionRef === 'function') {
      sectionRef(node);
    } else if (sectionRef) {
      sectionRef.current = node;
    }
  }, [sectionRef]);
  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active = document.fullscreenElement === el || document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
    };
    document.addEventListener('fullscreenchange', syncFullscreen);
    document.addEventListener('webkitfullscreenchange', syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener('fullscreenchange', syncFullscreen);
      document.removeEventListener('webkitfullscreenchange', syncFullscreen);
    };
  }, []);
  return <div className={`accountsCard${isFullscreen ? ' is-fullscreen' : ''}`} ref={setAccountsRootRef}>
      <div className="accountsCard__panel">
        <CardHeading title="Accounts" />
        <AccountTable walletList={walletList} />
      </div>
    </div>;
};
export default Accounts;